import { useEffect, useRef, useState } from "react";

/**
 * Custom hook to track horizontal scroll state of a container
 * @returns {object} - { containerRef, showShadow }
 */
const useScrollShadow = () => {
  const containerRef = useRef(null);
  const [showShadow, setShowShadow] = useState(false);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const handleScroll = () => {
      setShowShadow(container.scrollLeft > 0);
    };

    container.addEventListener("scroll", handleScroll);

    return () => {
      container.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return { containerRef, showShadow };
};

export default useScrollShadow;